module.exports = __webpack_public_path__ + "static/img/5.2.8b97322.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/5.2.png
// module id = Qbt1
// module chunks = 0